import { isServerRendering } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { PurchaseConfirmationForm } from '../../../../../../Common/Pim/Enums/PurchaseConfirmationForm.csharp';
import { PictureProfile } from '../../../../../../ResizedImage/PictureProfile.csharp';
import { DuraphatSettings } from '../../../../../Blocks/FormsConfiguration/Duraphat/DuraphatSettings.csharp';
import { IFormConfiguration } from '../../../../../Blocks/FormsConfiguration/IFormConfiguration.csharp';
import { DuraphatForm } from '../../../../../ReactComponents/PurchaseConfirmationForms/DuraphatForm/DuraphatForm';
import { ViagraForm } from '../../../../../ReactComponents/PurchaseConfirmationForms/ViagraForm/ViagraForm';
import { ResponsivePictureViewModel } from '../../../../../ReactComponents/ResponsivePicture/ResponsivePictureViewModel.csharp';

interface AddToCartFormsProps {
    formConfiguration: IFormConfiguration;
    addToCart: () => void;
    closeForm: () => void;
    productBrand: string;
    productName: string;
    productPrice: number;
    productImage: ResponsivePictureViewModel;
    pictureProfile: PictureProfile;
    isFormVisible: boolean;
}

export const AddToCartForms = (props: AddToCartFormsProps) => {
    const { formConfiguration, isFormVisible, addToCart, closeForm, productBrand, productName, pictureProfile, productImage, productPrice } = props;
    const modalRoot = !isServerRendering() && document.getElementById('modal-root');

    return modalRoot ? (
        <>
            {formConfiguration.type === PurchaseConfirmationForm.Viagra &&
                ReactDOM.createPortal(
                    <ViagraForm
                        isVisible={isFormVisible}
                        addToCart={addToCart}
                        closeForm={closeForm}
                        mainName={productBrand}
                        additionalName={productName}
                        price={productPrice}
                        image={productImage}
                        profile={pictureProfile}
                    />,
                    modalRoot
                )}

            {formConfiguration.type === PurchaseConfirmationForm.Duraphat &&
                ReactDOM.createPortal(
                    <DuraphatForm
                        pictureProfile={pictureProfile}
                        isVisible={isFormVisible}
                        addToCart={addToCart}
                        closeForm={closeForm}
                        image={productImage}
                        brandName={productBrand}
                        productName={productName}
                        productPrice={productPrice}
                        formConfiguration={formConfiguration as DuraphatSettings}
                    />,
                    modalRoot
                )}
        </>
    ) : null;
};
